import { render, staticRenderFns } from "./NLCodes.vue?vue&type=template&id=49085df1&"
import script from "./NLCodes.vue?vue&type=script&lang=js&"
export * from "./NLCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports